import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useLayoutContext } from '../../Contexts/LayoutContext';
import { useStoreHook } from '../../Hooks/StoreHook';
import FormRegister from '../Form/FormRegister';
import DefaultLayout from '../../Layouts/DefaultLayout';

const Register = () => {
    const { t } = useTranslation();
    const { company } = useLayoutContext();
    const { loadCompanyInfo } = useStoreHook();

    useEffect(() => {
        if (!company) {
            loadCompanyInfo();
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <DefaultLayout className='bg-gray-50'>
            <section className='flex flex-col items-center gap-6 md:gap-8 w-full transition-all ease-in-out p-0 py-4 md:p-6 animate-fade-in'>

                <div className='flex flex-col gap-3 items-center text-center'>
                    <h1 className="text-3xl font-bold text-shopfood-title text-center text-gray-700">
                        {t('register.title')}
                    </h1>
                    <p className="text-gray-500 font-medium leading-none mx-auto mx-3 md:mx-6 text-lg">
                        {t('register.description')}
                    </p>
                </div>

                <div className='w-full max-w-4xl'>
                    <FormRegister />
                </div>

            </section>
        </DefaultLayout>
    );
};

export default Register;